import { Link } from 'react-router';
import { Zap } from 'lucide-react';
import { cn } from '@/lib/utils';

export function Brand({ to = '/', className }: { to?: string; className?: string }) {
  return (
    <Link
      to={to}
      aria-label="PredictX home"
      className={cn(
        'inline-flex shrink-0 items-center gap-2.5 rounded-md font-display text-lg font-bold tracking-[0.04em]',
        className,
      )}
    >
      <span className="arena-cut flex size-9 items-center justify-center bg-primary text-primary-foreground">
        <Zap className="size-5" aria-hidden="true" />
      </span>
      <span>
        PREDICT<span className="text-primary">X</span>
      </span>
    </Link>
  );
}
